import {z} from 'zod';
import {BaseIntegrationSchema} from './common';

export const WebIntentIntegrationSchema = BaseIntegrationSchema.extend({
  type: z.literal('webIntent'),
  trackingScriptId: z.string(),
  // Set when we first receive data from the installed tag
  firstDataReceivedAt: z.date().optional(),
  trackingScriptDetectedAt: z.date().optional(),
});

export type WebIntentIntegration = z.infer<typeof WebIntentIntegrationSchema>;
